import React, { useEffect } from 'react';
import useInputDate from '../../hooks/useInputDate';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import enLocale from 'date-fns/locale/en-GB';

const CustomFieldDate = ({ id, name, value, onChange, isReverting }) => {
    const input = useInputDate(value);

    useEffect(() => {
        onChange({ id, value: input.value, hasChanged: input.hasChanged });
    }, [input.value]);

    useEffect(() => {
        if (isReverting) {
            input.onRevert();
        }

    }, [isReverting]);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enLocale}>
            <DatePicker
                mask="__/__/____"
                format="dd/MM/yyyy"
                label={name}
                value={input.value}
                onChange={input.onChange}
                ampm
                slotProps={{
                    textField: {
                        size: 'small',
                        margin: 'none',
                        fullWidth: true
                    }
                }}
            />
        </LocalizationProvider>
    );
};

export default CustomFieldDate;